import React from "react";
import {Button, Card, CardBody, CardHeader, Input, Toast} from "gd-react";

const IPV4_RE = /^(25[0-5]|2[0-4]\d|[01]?\d?\d)(\.(25[0-5]|2[0-4]\d|[01]?\d?\d)){3}$/;

function ethernetFromItem(item) {
    let s = item && item.staticEthernetSettings ? item.staticEthernetSettings : {};
    return {
        address: s.address || '',
        gateway: s.gateway || '',
        dns: s.dns || ''
    };
}

class GatewayNetwork extends React.Component {
    constructor(props) {
        super(props);
        this.updatedExternally = this.updatedExternally.bind(this);
        this.transmitEthernetUpdate = this.transmitEthernetUpdate.bind(this);
        this.handleClose = this.handleClose.bind(this);
        this.state = {
            ethernet: ethernetFromItem(props.item),
            triedToSave: false,
            errors: {},
            open: false
        };
        if (props.item) {
            props.item.on('updated', this.updatedExternally);
        }
    }

    componentDidUpdate(prevProps) {
        if (prevProps.item !== this.props.item) {
            if (prevProps.item) prevProps.item.off('updated', this.updatedExternally);
            this.props.item.on('updated', this.updatedExternally);
            this.updatedExternally();
        }
    }

    componentWillUnmount() {
        if (this.props.item && this.props.item.off) {
            this.props.item.off('updated', this.updatedExternally);
        }
    }

    updatedExternally() {
        this.setState({ethernet: ethernetFromItem(this.props.item)});
    }

    transmitEthernetUpdate() {
        let e = this.state.ethernet;
        let errors = {};
        if (!IPV4_RE.test(e.address)) errors.address = true;
        if (!IPV4_RE.test(e.gateway)) errors.gateway = true;
        if (!IPV4_RE.test(e.dns)) errors.dns = true;
        if (Object.keys(errors).length) {
            this.setState({triedToSave: true, errors: errors});
            return Promise.reject();
        }
        return this.props.item.set({
            staticEthernetSettings: {
                address: e.address,
                gateway: e.gateway,
                dns: e.dns
            }
        }).then(() => {
            this.setState({triedToSave: false, errors: {}, open: true});
        });
    }

    handleClose() {
        this.setState({open: false});
    }

    render() {
        let self = this;
        let ethernet = this.state.ethernet;
        let errors = this.state.errors;
        let triedToSave = this.state.triedToSave;
        return (
            <div className={"page grey narrow not-flex"}>
                <div className={'column top'}>
                    <div className={'detail-content'}>
                        <Card>
                            <CardHeader title={'Pi-Duck Static Ethernet'}/>
                            <CardBody>
                                <div className={'row'} style={{marginBottom: '15px'}}>
                                    <Input
                                        top='true'
                                        label={'IP Address'}
                                        name={'static-ethernet-address'}
                                        placeholder={'e.g. 192.168.1.79'}
                                        value={ethernet.address}
                                        error={triedToSave && errors.address}
                                        onChange={(e) => self.setState({
                                            ethernet: {...ethernet, address: e.target.value}
                                        })}
                                    />
                                </div>
                                <div className={'row'} style={{marginBottom: '15px'}}>
                                    <Input
                                        label={'Gateway'}
                                        name={'static-ethernet-gateway'}
                                        placeholder={'e.g. 192.168.1.1'}
                                        value={ethernet.gateway}
                                        error={triedToSave && errors.gateway}
                                        onChange={(e) => self.setState({
                                            ethernet: {...ethernet, gateway: e.target.value}
                                        })}
                                    />
                                </div>
                                <div className={'row'} style={{marginBottom: '15px'}}>
                                    <Input
                                        label={'DNS'}
                                        name={'static-ethernet-dns'}
                                        placeholder={'e.g. 192.168.1.1'}
                                        value={ethernet.dns}
                                        error={triedToSave && errors.dns}
                                        onChange={(e) => self.setState({
                                            ethernet: {...ethernet, dns: e.target.value}
                                        })}
                                    />
                                </div>
                                <Button
                                    onClick={this.transmitEthernetUpdate}
                                    progressRes
                                    additionalclasses={'sm'}
                                    color={'gd-green'}
                                    label={'Save'}
                                />
                            </CardBody>
                        </Card>
                    </div>
                </div>
                <Toast onClose={this.handleClose} message={"Save Successful"}
                       anchorOrigin={{vertical: 'bottom', horizontal: 'left'}}
                       open={this.state.open}/>
            </div>
        );
    }
}

export default GatewayNetwork;
